import { render, staticRenderFns } from "./ComboboxTerritoriosReponsaveis.vue?vue&type=template&id=4def9602"
import script from "./ComboboxTerritoriosReponsaveis.vue?vue&type=script&lang=js"
export * from "./ComboboxTerritoriosReponsaveis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports